import { useTranslation } from 'react-i18next'

export function useDateLocale() {
  const { i18n } = useTranslation()
  return i18n.language === 'zh-CN' ? 'zh-CN' : 'en-US'
}

export function useFormattedDate() {
  const locale = useDateLocale()

  const formatDate = (date: string | Date) => {
    return new Date(date).toLocaleDateString(locale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
  }

  const formatDateTime = (date: string | Date) => {
    return new Date(date).toLocaleString(locale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    })
  }

  return { formatDate, formatDateTime }
}
